import { api } from './index';

import type { GrowthPlan } from '@/types';

export interface GrowthPlansApiOptions {
  userId?: string;
}

export interface GetGrowthPlanParams {
  id: string;
}

export const growthPlanApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getGrowthPlan: builder.query<GrowthPlan, GetGrowthPlanParams>({
      providesTags: (_result, _error, { id }) => [{ id, type: 'GrowthPlan' }],
      query: ({ id }) => ({ method: 'GET', url: `/growth_plans/${id}` }),
    }),
    getGrowthPlans: builder.query<
      GrowthPlan[],
      GrowthPlansApiOptions | undefined
    >({
      providesTags: ['GrowthPlan'],
      query: (params) => ({
        method: 'GET',
        params,
        url: '/growth_plans',
      }),
    }),
    updateGrowthPlan: builder.mutation<GrowthPlan, Partial<GrowthPlan>>({
      invalidatesTags: (_result, _error, { id }) => [
        { id, type: 'GrowthPlan' },
        'GrowthPlan',
      ],
      query: ({ id, ...growthPlan }) => ({
        data: growthPlan,
        method: 'PATCH',
        url: `/growth_plans/${id}`,
      }),
    }),
  }),
});

export const {
  useGetGrowthPlanQuery,
  useGetGrowthPlansQuery,
  useUpdateGrowthPlanMutation,
} = growthPlanApi;
